<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Product name</mat-label>
        <input
          [readonly]="editMode"
          [(ngModel)]="productListData.product_name"
          matInput
          #input
        />
       
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          [readonly]="editMode"
          [(ngModel)]="productListData.product_desc"
          matInput
        ></textarea>
       
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>HSN code</mat-label>
        <input
          [(ngModel)]="productListData.hsn_code"
          matInput
          #input
        />
       
      </mat-form-field>
    </div>
    <div *ngIf="!editMode || (editMode && !productListData.inventory_item_hash)">
      <mat-form-field appearance="outline">
        <mat-label>Selling unit</mat-label>
        <input
          [(ngModel)]="productListData.selling_unit"
          matInput
          #input
        />
       
      </mat-form-field>
    </div>
    <div *ngIf="!editMode || (editMode && !productListData.inventory_item_hash)">
      <mat-form-field appearance="outline">
        <mat-label>Selling quantity</mat-label>
        <input
          smDecimalOnly type="number"
          [(ngModel)]="productListData.qty_info"
          matInput
          #input
        />
       
      </mat-form-field>
    </div>
    
    <div style="margin-bottom: 15px;">
<!-- 
            
            <mat-checkbox value="shop" (change)="change($event)" [checked]="isShop"></mat-checkbox>
            <mat-label>Shop service</mat-label>
            
            <mat-checkbox value="home" (change)="change($event)" [checked]="isHome"></mat-checkbox>
            <mat-label>Home service</mat-label>
                        
            <mat-checkbox value="virtual" (change)="change($event)" ></mat-checkbox>
            <mat-label>Virtual service</mat-label> -->

            <mat-checkbox value="shop" (change)="change($event)" [checked]="isShop" *ngIf="shop_status != '2'"></mat-checkbox>
            <mat-label *ngIf="shop_status != '2'">Shop service</mat-label>
            
            <mat-checkbox value="home" (change)="change($event)" [checked]="isHome" *ngIf="home_status != '2'"></mat-checkbox>
            <mat-label *ngIf="home_status != '2'">Home service</mat-label>
            
            <mat-checkbox value="virtual" (change)="change($event)" [checked]="isVirtual" *ngIf="virtual_status != '2'"></mat-checkbox>
            <mat-label *ngIf="virtual_status != '2'">Virtual service</mat-label>
            
         
            
    </div>
  
    <div *ngIf="isShopSpecific == true">
        <mat-form-field appearance="outline">
          <mat-label>Shop rate</mat-label>
          <input smDecimalOnly type="number"
          [(ngModel)]="productListData.shop_price"
          matInput
        
        />
         
        </mat-form-field>
    </div>
    <div *ngIf="isHomeSpecific == true">
      <mat-form-field appearance="outline">
        <mat-label>Home rate</mat-label>
        <input smDecimalOnly type="number"
        [(ngModel)]="productListData.home_price"
        matInput
      
      />
        
      </mat-form-field>
  </div>
  <div *ngIf="isVirtualSpecific == true">
    <mat-form-field appearance="outline">
      <mat-label>Virtual rate</mat-label>
      <input 
      [(ngModel)]="productListData.virtual_price"
      smDecimalOnly type="number"
      matInput
    
    />
      
    </mat-form-field>
</div>
<div>
    <mat-form-field appearance="outline">
      <mat-label>Manufacturer</mat-label>
      <input
        [(ngModel)]="productListData.manufacturer"
        matInput
        #input
      />
     
    </mat-form-field>
  </div>
   <p *ngIf="editMode && productListData.inventory_item_hash" style="margin-bottom: 20px;">Selling quantity info: <br><strong>{{productListData.qty_info}} {{productListData.selling_unit}}</strong> </p>
    <!-- <div>
      <mat-form-field appearance="outline">
        <mat-label>Approx time(in minutes)</mat-label>
        <input smNumericOnly
          [(ngModel)]="productListData.approxTime"
          matInput

        />
       
      </mat-form-field>
    </div> -->
    <div style="margin-bottom: 10px;">
        <mat-label>Enable discount</mat-label>
        <mat-slide-toggle style="    margin-left: 20px;
        position: relative;
        top: 2px;
    " class="share" (change)="onToggleChange($event)" [checked]="isDiscountApplicable"></mat-slide-toggle>
      <br><br>
        <!--         <input type="radio" id="yes" name="discountApplicable" value="applicable" [checked]="isDiscount == true" (click)="onApp($event)">
        <label for="yes" class="radlabel">Yes</label>
        <input type="radio" id="no" name="discountApplicable" [checked]="isDiscount == false" value="not-applicable" (click)="onApp($event)">
        <label for="no" class="radlabel">No</label> -->

    </div>
    <div *ngIf="productListData.discount_status == '1'" style="margin-bottom: 10px;">
        <mat-label>Discount type</mat-label>
        <br><br>


        <input type="radio" id="percent" name="discountType" [checked]="isPercent == true" value="percent" (click)="discType($event)">
        <label for="percent" class="radlabel">Percent</label>
        <input type="radio" id="amount" name="discountType" [checked]="isAmount == true" value="amount" (click)="discType($event)">
        <label for="amount" class="radlabel">Amount</label>

    </div>
    <div *ngIf="productListData.discount_status == '1'">
        <mat-form-field appearance="outline">
          <mat-label>Discount Amount</mat-label>
          <input smDecimalOnly type="number"
            [(ngModel)]="productListData.discount"
            matInput
  
          />
         
        </mat-form-field>
      </div>

      <div style="margin-bottom: 10px;">
        <mat-label>Enable tax</mat-label>
        <mat-slide-toggle style="    margin-left: 20px;
        position: relative;
        top: 2px;
    " class="share" (change)="onToggleChangeForTax($event)" [checked]="isTaxApplicable"></mat-slide-toggle>
      <br><br>
        <!--         <input type="radio" id="yes" name="discountApplicable" value="applicable" [checked]="isDiscount == true" (click)="onApp($event)">
        <label for="yes" class="radlabel">Yes</label>
        <input type="radio" id="no" name="discountApplicable" [checked]="isDiscount == false" value="not-applicable" (click)="onApp($event)">
        <label for="no" class="radlabel">No</label> -->

    </div>
      <!-- [(value)]="selectedView" [(ngModel)]="selectedView" (ngModelChange)="changeView()" -->
       <div *ngIf="isTaxApplicable && taxSlabData.length > 0">
        <mat-form-field appearance="outline">
           <mat-select [(value)]="selectedSlab" [(ngModel)]="selectedSlab" class="w-100">
                       <mat-option value="default" >
                         Select a tax
                       </mat-option>
                       <mat-option [value]="item.hash_id" *ngFor="let item of taxSlabData">
                         {{isEntityForeign == '0' ? item.tax_name : item.slab_name}}

                       </mat-option>
                      
                     </mat-select>
        </mat-form-field>
       </div>
       <div *ngIf="isTaxApplicable && taxSlabData.length == 0">
        <p>Tax not configured yet. <a href="javascript:void(0)" (click)="configureTax()">Click to configure</a></p>
       </div>
    <!-- <input type="text" placeholder="Enter name" /> -->
    <div style="display: flex; justify-content: center; align-items: center">
      <mat-spinner [diameter]="20" *ngIf="loader"></mat-spinner>
    </div>
    <div class="image-preview" *ngIf="assetList.length > 0" style="position: relative;    width: fit-content;    margin-bottom: 20px;    border: 1px solid lightgray;
      padding: 15px;
  ">
      <img [src]="assetList[assetList.length - 1].url" alt="" style="width: 200px; height: 170px; object-fit: cover;">
      <span (click)="removeAsset()" style="position: absolute;
      cursor: pointer;
      top: 0;
      right: 0;
      background: #dd2c00;
      border-radius: 50%;
      height: 30px;
      width: 30px;" ><mat-icon style="    position: absolute;
    left: 3px;
    top: 2px;
    color: white;" class="material-icons-outlined">close</mat-icon></span>
    </div>
    <div class="upload-group mb-2">
      <label for="formFile" class="form-label">Upload media</label>
      <div class="file-input-wrap">
        <div class="custom-input-label">
          <mat-icon class="material-icons-outlined" class="mb-1" color="primary"
            >backup</mat-icon
          >
          <p>Drop your file(s) here or <span>browse</span></p>
        </div>
        <input
          class="form-control"
          id="formFile"
          accept="image/*"
          type="file"
          multiple
          (change)="onUploadImage($event)"
        />
      </div>
      <!-- <mat-chip-list #chipList style="margin-top: 2px">
        <mat-chip style="width: 100%; padding: 10px">File</mat-chip>
      </mat-chip-list> -->
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        !productListData.product_name ||
        !productListData.product_desc ||
        priceCheker() ||
        discountChecker()
      "
      (click)="onPost()"
    >
      {{ editMode ? "Edit" : "Add" }}
    </button>
  </mat-dialog-actions>
  